export default "__VITE_ASSET__O4LbT8st__"